import axios from 'axios'

const request = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "/api",
  // 超时
  timeout: 50000
})

export default request



// WEBPACK FOOTER //
// ./src/api/request.js